"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _getIterator2 = require("babel-runtime/core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

exports.getDocumentationUrlFromHeaders = getDocumentationUrlFromHeaders;
exports.default = parseHydraDocumentation;

var _jsonld = require("jsonld");

var _lodash = require("lodash.get");

var _lodash2 = _interopRequireDefault(_lodash);

var _Api = require("../Api");

var _Api2 = _interopRequireDefault(_Api);

var _Field = require("../Field");

var _Field2 = _interopRequireDefault(_Field);

var _Resource = require("../Resource");

var _Resource2 = _interopRequireDefault(_Resource);

var _Operation = require("../Operation");

var _Operation2 = _interopRequireDefault(_Operation);

var _fetchJsonLd = require("./fetchJsonLd");

var _fetchJsonLd2 = _interopRequireDefault(_fetchJsonLd);

var _addParameters = require("./addParameters");

var _addParameters2 = _interopRequireDefault(_addParameters);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Extracts the short name of a resource.
 *
 * @param {string} url
 * @param {string} entrypointUrl
 * @return {string}
 */


function guessNameFromUrl(url, entrypointUrl) {
  return url.substr(entrypointUrl.length + 1);
}
/**
 * Finds the description of the class with the given id.
 *
 * @param {object[]} docs
 * @param {string} classToFind
 * @return {object}
 */


function findSupportedClass(docs, classToFind) {
  var supportedClasses = (0, _lodash2.default)(docs, '[0]["http://www.w3.org/ns/hydra/core#supportedClass"]');

  if (!Array.isArray(supportedClasses)) {
    throw new Error('The API documentation has no "http://www.w3.org/ns/hydra/core#supportedClass" key or its value is not an array.');
  }

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = (0, _getIterator3.default)(supportedClasses), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var supportedClass = _step.value;

      if (supportedClass["@id"] === classToFind) {
        return supportedClass;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  throw new Error("The class \"" + classToFind + "\" is not defined in the API documentation.");
}

function getDocumentationUrlFromHeaders(headers) {
  var linkHeader = headers.get("Link");

  if (!linkHeader) {
    throw new Error('The response has no "Link" HTTP header.');
  }

  var matches = linkHeader.match(/<(.+)>; rel="http:\/\/www.w3.org\/ns\/hydra\/core#apiDocumentation"/);

  if (!matches[1]) {
    throw new Error('The "Link" HTTP header is not of the type "http://www.w3.org/ns/hydra/core#apiDocumentation".');
  }

  return matches[1];
}
/**
 * Retrieves Hydra's entrypoint and API docs.
 *
 * @param {string} entrypointUrl
 * @param {object} options
 * @return {Promise}
 */


function fetchEntrypointAndDocs(entrypointUrl) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (0, _fetchJsonLd2.default)(entrypointUrl, options).then(function (d) {
    var docsUrl = getDocumentationUrlFromHeaders(d.response.headers);
    return {
      entrypointUrl: entrypointUrl,
      docsUrl: docsUrl,
      entrypoint: d.body,
      response: d.response
    };
  }).then(function (data) {
    return (0, _fetchJsonLd2.default)(data.docsUrl, options).then(function (d) {
      data.docs = d.body;
      return data;
    }).then(function (data) {
      return _jsonld.promises.expand(data.docs, {
        base: data.docsUrl,
        documentLoader: function documentLoader(input) {
          return (0, _fetchJsonLd2.default)(input, options);
        }
      }).then(function (docs) {
        data.docs = docs;
        return data;
      });
    }).then(function (data) {
      return _jsonld.promises.expand(data.entrypoint, {
        base: data.entrypointUrl,
        documentLoader: function documentLoader(input) {
          return (0, _fetchJsonLd2.default)(input, options);
        }
      }).then(function (entrypoint) {
        data.entrypoint = entrypoint;
        return data;
      });
    });
  });
}

function removeTrailingSlash(url) {
  if (/\/$/.test(url)) {
    url = url.slice(0, -1);
  }

  return url;
}
/**
 *
 * @param {object} docs
 * @param {object} property
 * @return {string|null}
 */


function findRelatedClass(docs, property) {
  // Use the entrypoint property's owl:equivalentClass if available
  if (Array.isArray(property["http://www.w3.org/2000/01/rdf-schema#range"])) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = (0, _getIterator3.default)(property["http://www.w3.org/2000/01/rdf-schema#range"]), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var range = _step2.value;
        var onProperty = (0, _lodash2.default)(range, '["http://www.w3.org/2002/07/owl#equivalentClass"][0]["http://www.w3.org/2002/07/owl#onProperty"][0]["@id"]');
        var allValuesFrom = (0, _lodash2.default)(range, '["http://www.w3.org/2002/07/owl#equivalentClass"][0]["http://www.w3.org/2002/07/owl#allValuesFrom"][0]["@id"]');

        if (allValuesFrom && "http://www.w3.org/ns/hydra/core#member" === onProperty) {
          return findSupportedClass(docs, allValuesFrom);
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  } // As a fallback, find an operation available on the property of the entrypoint returning the searched type (usually POST)


  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = (0, _getIterator3.default)(property["http://www.w3.org/ns/hydra/core#supportedOperation"]), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var entrypointSupportedOperation = _step3.value;

      if (!entrypointSupportedOperation["http://www.w3.org/ns/hydra/core#returns"]) {
        continue;
      }

      var returns = (0, _lodash2.default)(entrypointSupportedOperation, '["http://www.w3.org/ns/hydra/core#returns"][0]["@id"]');

      if ("string" === typeof returns && 0 !== returns.indexOf("http://www.w3.org/ns/hydra/core")) {
        return findSupportedClass(docs, returns);
      }
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  throw new Error("Cannot find the class related to " + property["@id"] + ".");
}
/**
 * Parses a Hydra documentation and converts it to an intermediate representation.
 *
 * @param {string} entrypointUrl
 * @param {object} options
 * @return {Promise.<Api>}
 */


function parseHydraDocumentation(entrypointUrl) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  entrypointUrl = removeTrailingSlash(entrypointUrl);
  return fetchEntrypointAndDocs(entrypointUrl, options).then(function (_ref) {
    var entrypoint = _ref.entrypoint,
        docs = _ref.docs,
        response = _ref.response;
    var resources = [],
        fields = [],
        operations = [];
    var title = (0, _lodash2.default)(docs, '[0]["http://www.w3.org/ns/hydra/core#title"][0]["@value"]', "API Platform");
    var entrypointType = (0, _lodash2.default)(entrypoint, '[0]["@type"][0]');

    if (!entrypointType) {
      throw new Error('The API entrypoint has no "@type" key.');
    }

    var entrypointClass = findSupportedClass(docs, entrypointType);

    if (!Array.isArray(entrypointClass["http://www.w3.org/ns/hydra/core#supportedProperty"])) {
      throw new Error('The entrypoint definition has no "http://www.w3.org/ns/hydra/core#supportedProperty" key or it is not an array.');
    } // Add resources


    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
      for (var _iterator4 = (0, _getIterator3.default)(entrypointClass["http://www.w3.org/ns/hydra/core#supportedProperty"]), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
        var properties = _step4.value;
        var readableFields = [],
            resourceFields = [],
            writableFields = [],
            resourceOperations = [];
        var property = (0, _lodash2.default)(properties, '["http://www.w3.org/ns/hydra/core#property"][0]');

        if (!property) {
          continue;
        } // Add fields


        var relatedClass = findRelatedClass(docs, property);
        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
          for (var _iterator6 = (0, _getIterator3.default)(relatedClass["http://www.w3.org/ns/hydra/core#supportedProperty"]), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
            var supportedProperties = _step6.value;
            var supportedProperty = (0, _lodash2.default)(supportedProperties, '["http://www.w3.org/ns/hydra/core#property"][0]');

            var _range = (0, _lodash2.default)(supportedProperty, '["http://www.w3.org/2000/01/rdf-schema#range"][0]["@id"]', null);

            var field = new _Field2.default(supportedProperty["http://www.w3.org/2000/01/rdf-schema#label"][0]["@value"], {
              id: supportedProperty["@id"],
              range: _range,
              reference: "http://www.w3.org/ns/hydra/core#Link" === (0, _lodash2.default)(property, '["@type"][0]') ? _range : null,
              // Will be updated in a subsequent pass
              required: (0, _lodash2.default)(supportedProperties, '["http://www.w3.org/ns/hydra/core#required"][0]["@value"]', false),
              description: (0, _lodash2.default)(supportedProperties, '["http://www.w3.org/ns/hydra/core#description"][0]["@value"]', ""),
              maxCardinality: (0, _lodash2.default)(supportedProperty, '["http://www.w3.org/2002/07/owl#maxCardinality"][0]["@value"]', null),
              deprecated: (0, _lodash2.default)(supportedProperties, '["http://www.w3.org/2002/07/owl#deprecated"][0]["@value"]', false)
            });
            fields.push(field);
            resourceFields.push(field);

            if ((0, _lodash2.default)(supportedProperties, '["http://www.w3.org/ns/hydra/core#readable"][0]["@value"]')) {
              readableFields.push(field);
            }

            if ((0, _lodash2.default)(supportedProperties, '["http://www.w3.org/ns/hydra/core#writable"][0]["@value"]')) {
              writableFields.push(field);
            }
          } // parse entrypoint's operations (a.k.a. collection operations)

        } catch (err) {
          _didIteratorError6 = true;
          _iteratorError6 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion6 && _iterator6.return) {
              _iterator6.return();
            }
          } finally {
            if (_didIteratorError6) {
              throw _iteratorError6;
            }
          }
        }

        if (property["http://www.w3.org/ns/hydra/core#supportedOperation"]) {
          var _iteratorNormalCompletion7 = true;
          var _didIteratorError7 = false;
          var _iteratorError7 = undefined;

          try {
            for (var _iterator7 = (0, _getIterator3.default)(property["http://www.w3.org/ns/hydra/core#supportedOperation"]), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
              var entrypointOperation = _step7.value;

              if (!entrypointOperation["http://www.w3.org/ns/hydra/core#returns"]) {
                continue;
              }

              var range = entrypointOperation["http://www.w3.org/ns/hydra/core#returns"][0]["@id"];
              var operation = new _Operation2.default(entrypointOperation["http://www.w3.org/2000/01/rdf-schema#label"][0]["@value"], {
                method: entrypointOperation["http://www.w3.org/ns/hydra/core#method"][0]["@value"],
                expects: entrypointOperation["http://www.w3.org/ns/hydra/core#expects"] && entrypointOperation["http://www.w3.org/ns/hydra/core#expects"][0]["@id"],
                returns: range,
                types: entrypointOperation["@type"],
                deprecated: (0, _lodash2.default)(entrypointOperation, '["http://www.w3.org/2002/07/owl#deprecated"][0]["@value"]', false)
              });
              resourceOperations.push(operation);
              operations.push(operation);
            }
          } catch (err) {
            _didIteratorError7 = true;
            _iteratorError7 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion7 && _iterator7.return) {
                _iterator7.return();
              }
            } finally {
              if (_didIteratorError7) {
                throw _iteratorError7;
              }
            }
          }
        } // parse resource operations (a.k.a. item operations)


        var _iteratorNormalCompletion8 = true;
        var _didIteratorError8 = false;
        var _iteratorError8 = undefined;

        try {
          for (var _iterator8 = (0, _getIterator3.default)(relatedClass["http://www.w3.org/ns/hydra/core#supportedOperation"]), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
            var supportedOperation = _step8.value;

            if (!supportedOperation["http://www.w3.org/ns/hydra/core#returns"]) {
              continue;
            }

            var _range2 = supportedOperation["http://www.w3.org/ns/hydra/core#returns"][0]["@id"];

            var _operation = new _Operation2.default(supportedOperation["http://www.w3.org/2000/01/rdf-schema#label"][0]["@value"], {
              method: supportedOperation["http://www.w3.org/ns/hydra/core#method"][0]["@value"],
              expects: supportedOperation["http://www.w3.org/ns/hydra/core#expects"] && supportedOperation["http://www.w3.org/ns/hydra/core#expects"][0]["@id"],
              returns: _range2,
              types: supportedOperation["@type"],
              deprecated: (0, _lodash2.default)(supportedOperation, '["http://www.w3.org/2002/07/owl#deprecated"][0]["@value"]', false)
            });

            resourceOperations.push(_operation);
            operations.push(_operation);
          }
        } catch (err) {
          _didIteratorError8 = true;
          _iteratorError8 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion8 && _iterator8.return) {
              _iterator8.return();
            }
          } finally {
            if (_didIteratorError8) {
              throw _iteratorError8;
            }
          }
        }

        var url = (0, _lodash2.default)(entrypoint, "[0][\"" + property["@id"] + "\"][0][\"@id\"]");

        if (!url) {
          throw new Error("Unable to find the URL for \"" + property["@id"] + "\".");
        }

        resources.push(new _Resource2.default(guessNameFromUrl(url, entrypointUrl), url, {
          id: relatedClass["@id"],
          title: (0, _lodash2.default)(relatedClass, '["http://www.w3.org/ns/hydra/core#title"][0]["@value"]', ""),
          fields: resourceFields,
          readableFields: readableFields,
          writableFields: writableFields,
          operations: resourceOperations,
          deprecated: (0, _lodash2.default)(relatedClass, '["http://www.w3.org/2002/07/owl#deprecated"][0]["@value"]', false),
          parameters: []
        }));
      } // Resolve references

    } catch (err) {
      _didIteratorError4 = true;
      _iteratorError4 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion4 && _iterator4.return) {
          _iterator4.return();
        }
      } finally {
        if (_didIteratorError4) {
          throw _iteratorError4;
        }
      }
    }

    var _iteratorNormalCompletion5 = true;
    var _didIteratorError5 = false;
    var _iteratorError5 = undefined;

    try {
      var _loop = function _loop() {
        var field = _step5.value;

        if (null !== field.reference) {
          field.reference = resources.find(function (resource) {
            return resource.id === field.reference;
          }) || null;
        }
      };

      for (var _iterator5 = (0, _getIterator3.default)(fields), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
        _loop();
      }
    } catch (err) {
      _didIteratorError5 = true;
      _iteratorError5 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion5 && _iterator5.return) {
          _iterator5.return();
        }
      } finally {
        if (_didIteratorError5) {
          throw _iteratorError5;
        }
      }
    }

    return _promise2.default.resolve({
      api: new _Api2.default(entrypointUrl, {
        title: title,
        resources: resources
      }),
      response: response,
      status: response.status
    });
  }, function (data) {
    return _promise2.default.reject({
      api: new _Api2.default(entrypointUrl, {
        resources: []
      }),
      error: data,
      response: data.response,
      status: (0, _lodash2.default)(data.response, "status")
    });
  }).then(function (_ref2) {
    var api = _ref2.api,
        response = _ref2.response,
        status = _ref2.status;
    return (0, _addParameters2.default)(api, options).then(function (api) {
      return {
        api: api,
        response: response,
        status: status
      };
    });
  });
}